<div
  *ngIf="steps.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header">
  <table
    mat-table
    [dataSource]="steps"
    class="sp-width__full">
    <ng-container matColumnDef="step_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STEPS.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <app-shared-id
          [content]="step.step_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="index">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STEPS.INDEX_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <span class="sp-color__primary sp-text__ellipsized"> {{ step.index }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="qinetic">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">Qinetic ID</span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <app-shared-id
          *ngIf="step.position_id"
          [content]="step.position_id"
          [content_class]="'sp-color__green sp-text__bold'"
          [is_shrinked_id]="false"></app-shared-id>
        <span *ngIf="!step.position_id && !step.position_error"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="buyer">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.BUYER_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <app-shared-id
          [content]="step.buyer_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.REGISTRATION_DATE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <span class="sp-color__primary sp-text__ellipsized"> {{ step.created_at | date : 'short' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="due_date">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STEPS.DUE_DATE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <span class="sp-color__primary sp-text__ellipsized"> {{ step.due_date | date : 'short' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="payment_date">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STEPS.PAYMENT_DATE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <span
          *ngIf="getPaymentDate(step) as payment_date"
          class="sp-color__primary sp-text__ellipsized">
          {{ payment_date | date : 'short' }}
          <span
            *ngIf="getPaymentSource(step) as source"
            class="sp-text__small sp-color__grey">
            ({{ source | translate }})
          </span>
        </span>
        <span *ngIf="!getPaymentDate(step)"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <div
          [ngClass]="getStepStatusClass(step.status)"
          class="sp-order__status-radius sp-row__center sp-padding__horiz sp-width__fit-content">
          <span class="sp-text__ellipsized sp-text__center">{{ step.status }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="order_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.ORDER_ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <app-shared-id
          [content]="step.order_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'GENERAL.AMOUNT_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <span class="sp-text__ellipsized">
          <b>{{ step.amount?.total / 100 || 0 | number : '0.2-2' }} {{ getCurrencyLabel(step) }}</b>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.ACTIONS_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <div class="sp-row__align">
          <button
            (click)="onQineticReloadClick(step)"
            [disabled]="![completed_step_status].includes(step.status)"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent"
            [matTooltip]="'ORDERS.QINETIC_RETRY_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> reply </mat-icon>
          </button>
          <button
            (click)="onRequestsClick(step)"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent sp-margin__left"
            [matTooltip]="'GENERAL.SEE_REQUESTS_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> list </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayed_columns"></tr>
  </table>
</div>
